import React from "react";

const AuthContext = React.createContext({
  token: null,
  isAuthenticated: false,
  login: (token) => {},
  logout: () => {},
});

export const AuthContextProvider = ({ children }) => {
  const initialSession = localStorage.getItem("token");
  const [session, setSession] = React.useState(initialSession);

  const isUserAuthenticated = !!session; //to prevent the content form non login user , we are checking the token in localStorage or browserStorage

  const loginHandler = (token) => {
    setSession(token);
    localStorage.setItem("token", token);
  };
  const logoutHandler = () => {
    setSession(null);
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{
        token: session,
        isAuthenticated: isUserAuthenticated,
        login: loginHandler,
        logout: logoutHandler,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
